<template>
  <div>
    <el-popover
      ref="popover"
      @show="showPopover = true"
      @hide="showPopover = false"
      v-model="showPopover"
      placement="bottom"
      width="450"
      trigger="click"
    >
      <el-input
        v-model="searchValue"
        slot="reference"
        :placeholder="selectMenu ? selectMenu.menuName : '请选择菜单'"
        :suffix-icon="showPopover ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
        readonly
      ></el-input>
      <el-tree
        style="max-height: 300px; overflow-y: auto"
        ref="menuSelectTree"
        :data="menuList"
        accordion
        :props="{
          label: 'menuName',
        }"
        node-key="id"
        :expand-on-click-node="false"
        highlight-current
        default-expand-all
        check-on-click-node
        @node-click="handleNodeClick"
        :filter-node-method="filterNode"
        :default-checked-keys="selectMenu ? [selectMenu.id] : null"
        :current-node-key="selectMenu ? selectMenu.id : null"
      ></el-tree>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "MenuTreeSelect",
  props: {
    value: {
      type: Object,
      default() {
        return this.$jsTool.topMenu();
      },
    },
    containTopNode: {
      type: Boolean,
      default: false,
    },
    containFrozen: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    searchValue(val) {
      if (!this.showPopover || !val || val == "") {
        return;
      } else {
        this.$refs.menuSelectTree.filter(val);
      }
    },
    value: {
      handler(val) {
        this.selectMenu = this.value
          ? this.value
          : this.containTopNode
          ? this.$jsTool.topMenu()
          : null;
        this.searchValue = this.selectMenu ? this.selectMenu.menuName : null;
      },
      immediate: true,
    },
  },
  data() {
    return {
      searchValue: null,
      showPopover: false,
      menuList: [],
      selectMenu: this.$jsTool.topMenu(),
    };
  },
  methods: {
    async flushData() {
      let requestRes = this.containFrozen
        ? await this.$api.sysMenu_findAllTree({
            showLoading: false,
          })
        : await this.$api.sysMenu_findUnFrozenTree({
            showLoading: false,
          });
      if (requestRes && requestRes.success) {
        this.menuList = this.containTopNode
          ? [].concat({
              ...this.$jsTool.topMenu(),
              children: requestRes.data,
            })
          : requestRes.data;
      }
    },
    handleNodeClick(e) {
      this.selectMenu = e;
      this.$emit("nodeClock", e);
      this.showPopover = false;
    },
    filterNode(value, data) {
      if (!this.showPopover || !value || value == "") {
        return true;
      }
      return data.menuName.indexOf(value) > -1;
    },
  },
  mounted() {
    this.flushData();
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/MenuTreeSelect.vue